import { render } from "./MainNav.vue?vue&type=template&id=cdecff9c&scoped=true&ts=true"
import script from "./MainNav.vue?vue&type=script&lang=ts"
export * from "./MainNav.vue?vue&type=script&lang=ts"

import "./MainNav.vue?vue&type=style&index=0&id=cdecff9c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cdecff9c"]])

export default __exports__